import { Mensaje } from "../../controls/Mensaje"
import { logErrors } from "../../logErrors"
import { insertar_veeduria, download_constancia } from "../../helpers/veeduriaHelper"
import { veeduriaTypes } from "../../types/veeduriaTypes"
import { insertVeeduria, downloadConstancia } from "../actions/veeduriaActions"
import { ProcesoEnd, ProcesoStart } from "../../controls/Proceso"


export const insertVeeduriaBD = (estudiante) => {
    return async( dispatch, getState ) => {
        try {
            const padre = getState().padre
            const informacion_basica = getState().informacion_basica

            // const { preguntas: preguntasTotal } = getState().pregunta
            // let preguntas;
            // let ptaUno = preguntasTotal.filter( e => e.ID == '189' )
            // let rptaUno = ptaUno[0].RESPUESTA[0]
            // switch (rptaUno) {
            //     case '619':     //  Presencial
            //         preguntas = preguntasTotal.filter( e => e.GRUPO_COD == '43' || e.GRUPO_COD == '44' || e.GRUPO_COD == '45' || e.GRUPO_COD == '46' || e.GRUPO_COD == '47' );
            //         break;
            
            //     case '620':     // Semipresencial
            //         preguntas = preguntasTotal.filter( e => e.GRUPO_COD == '43' || e.GRUPO_COD == '48' || e.GRUPO_COD == '49' || e.GRUPO_COD == '50' || e.GRUPO_COD == '51' );
            //         break;
                    
            //     case '621':     // A distancia
            //         preguntas = preguntasTotal.filter( e => e.GRUPO_COD == '43' || e.GRUPO_COD == '52' || e.GRUPO_COD == '53' );
            //         break;

            //     default:
            //         break;
            // }
            const { preguntas } = getState().pregunta

            dispatch( insertVeeduria() )
            
            ProcesoStart()
            const response = await insertar_veeduria({ informacion_basica, padre, estudiante, preguntas });

            if ( response.Validacion !== '' ){
                dispatch( { type: veeduriaTypes.VEEDURIA_SAVE_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
            }
            else{
                debugger;
                dispatch( { type: veeduriaTypes.VEEDURIA_SAVE_COMPLETE, 
                    payload: response.Data } );
            }
            
            ProcesoEnd()

        } catch ( e ) {
            ProcesoEnd()
            const err = logErrors( e )
            dispatch( { type: veeduriaTypes.VEEDURIA_SAVE_ERROR, payload: { message: err.Message, severity: 'error' } } );
            // dispatch( { type: veeduriaTypes.VEEDURIA_SAVE_ERROR, payload: { message: 'Se perdió la conexión.<br>Intente nuevamente por favor', severity: 'error' } } );
            Mensaje( err.Message, err.Type )
        }
        
    }
}



export const download = ( id ) => {
    return async( dispatch, getState ) => {
        try {
            console.log('download xxxxxxxx:', id)
            dispatch( downloadConstancia() )
            
            ProcesoStart()
            const response = await download_constancia(id);
debugger;
            if ( response == 1 )
                dispatch( { type: veeduriaTypes.VEEDURIA_DOWNLOAD_COMPLETE, payload: response.Data } );
            else
                dispatch( { type: veeduriaTypes.VEEDURIA_DOWNLOAD_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
            
            ProcesoEnd()


        } catch ( e ) {
            dispatch( { type: veeduriaTypes.VEEDURIA_DOWNLOAD_ERROR, payload: [] } );
            const err = logErrors( e )
            Mensaje( err.Message, err.Type )
            
        }
        
    }
}

